// Used also as 'resourceId'.
export const getUserProfileEndpoint = '/player-ms/v1/player/info';

// Used also as 'resourceId'.
export const getUserBalanceEndpoint = '/account-ms/v2/profile/balance';

export const infoLoginEndpoint = '/platform-service/ms/portal/infoLogin';

export const modifyProfileUsernameEndpoint =
  '/profilo-ms/ms/profile/modify/username';

export const modifyProfilePasswordEndpoint =
  '/profilo-ms/ms/profile/modify/password';

export const modifyProfileDomicileEndpoint =
  '/profilo-ms/ms/profile/update/domicile';

export const modifyProfileSecurityQuestionEndpoint =
  '/profilo-ms/ms/profile/modify/billSecurityQuestion';

export const modifyProfileContactsEndpoint =
  '/profilo-ms/ms/profile/modify/contacts';

export const modifyProfilePhoneNumberEndpoint =
  '/profilo-ms/ms/profile/update/cellphone';

export const modifyProfileEmailEndpoint = '/profilo-ms/ms/profile/update/email';

export const verifyPhoneEndpoint = 'profilo-ms/ms/profile/validate/loggedPhone';

export const getPinProfileEndpoint = 'profilo-ms/ms/profile/getAccountPin';

export const getGameContractEndpoint = 'profilo-ms/ms/profile/downloadContract';

export const closeAccountEndpoint = 'account-ms/v1/profile/closeAccount';
export const validateIbanEndpoint = 'account-ms/v1/validate/iban';
export const validateDocumentExpirationEndpoint =
  'account-ms/v1/validate/document-expiration';
export const validateBookingOperationsEndpoint =
  'account-ms/v1/validate/booking-operations';
